import { render, staticRenderFns } from "./FeeQuery.vue?vue&type=template&id=2fa15bc8&scoped=true"
import script from "./FeeQuery.vue?vue&type=script&lang=js"
export * from "./FeeQuery.vue?vue&type=script&lang=js"
import style0 from "./FeeQuery.vue?vue&type=style&index=0&id=2fa15bc8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa15bc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa15bc8')) {
      api.createRecord('2fa15bc8', component.options)
    } else {
      api.reload('2fa15bc8', component.options)
    }
    module.hot.accept("./FeeQuery.vue?vue&type=template&id=2fa15bc8&scoped=true", function () {
      api.rerender('2fa15bc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/const/FeeQuery.vue"
export default component.exports